import script from "./productSection.vue?vue&type=script&setup=true&lang=js"
export * from "./productSection.vue?vue&type=script&setup=true&lang=js"

import "./productSection.vue?vue&type=style&index=0&id=b86c0674&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b86c0674"]])

export default __exports__